module.exports = __webpack_public_path__ + "static/media/street-view.c99596de.svg";